import React from "react";

const PerimeterIconButton = ({ label, onClick, disabled, children }) => (
    <button
        type="button"
        title={label}
        aria-label={label}
        disabled={disabled}
        onClick={onClick}
        className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md border border-gray-200 bg-white hover:bg-gray-50 focus:border-yellow-500 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50"
    >
        {children}
    </button>
);

export default PerimeterIconButton;
